import React from "react";
import {Link as RouterLink} from "react-router-dom";
import {Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Container, Heading, Image, Text} from "@chakra-ui/react";
import {ChevronRightIcon} from "@chakra-ui/icons";

// crumbs: [{label, to?}] - the last crumb (without `to`) is the current page
export function Breadcrumbs({crumbs, light = false}) {
    const color = light ? "whiteAlpha.800" : "ink.500";
    return (
        <Breadcrumb separator={<ChevronRightIcon color={color}/>} fontSize="xs" textTransform="uppercase"
                    letterSpacing="0.12em" color={color} sx={{"ol": {flexWrap: "wrap"}}}>
            {crumbs.map((crumb) => (
                <BreadcrumbItem key={crumb.label}>
                    {crumb.to ? (
                        <BreadcrumbLink as={RouterLink} to={crumb.to} _hover={{color: light ? "white" : "brand.500"}}>
                            {crumb.label}
                        </BreadcrumbLink>
                    ) : (
                        <Text as="span" aria-current="page" color={light ? "white" : "ink.800"} noOfLines={1}>{crumb.label}</Text>
                    )}
                </BreadcrumbItem>
            ))}
        </Breadcrumb>
    );
}

function PageBanner({image, title, crumbs, children}) {
    return (
        <Box position="relative" bg="ink.900" color="white" overflow="hidden">
            {image && (
                <Image src={image} alt="" position="absolute" inset={0} w="100%" h="100%" objectFit="cover" opacity={0.42}/>
            )}
            <Box position="absolute" inset={0} bgImage="linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 75%)"/>
            <Container position="relative" maxW="container.xl" py={{base: 12, md: 20}}>
                {crumbs && <Breadcrumbs crumbs={crumbs} light/>}
                <Heading as="h1" color="white" fontSize={{base: "3xl", md: "5xl"}} textTransform="uppercase"
                         letterSpacing="0.02em" lineHeight={1.1} mt={4} maxW="4xl">
                    {title}
                </Heading>
                <Box w="56px" h="3px" bg="brand.500" mt={6}/>
                {children && <Box mt={5} maxW="2xl" color="whiteAlpha.900" fontSize={{base: "md", md: "lg"}}>{children}</Box>}
            </Container>
        </Box>
    );
}

export default PageBanner;
